import { CloseRoutesLogStore } from "@domain/stores/CloseRoutesLogStore";
import { create } from "zustand";

type InitialState = Pick<CloseRoutesLogStore, "closeRoutesLogs">;

const initialState: InitialState = {
  closeRoutesLogs: [],
};

const closeRoutesLogsStore = create<CloseRoutesLogStore>((set) => ({
  ...initialState,
  updateCloseRoutesLogs(newLogs) {
    set((state) => {
      return {
        ...state,
        closeRoutesLogs: newLogs,
      };
    });
  },
  clear: () => {
    set((state) => {
      return {
        ...state,
        ...initialState,
      };
    });
  },
}));

export default closeRoutesLogsStore;
